var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container"},[_c('i',{staticClass:"el-icon-loading",style:({color: _vm.iconColor})}),_c('p',{staticClass:"loading-text",style:({color: _vm.iconColor})},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }